import React, { useState } from 'react';
import { connect } from 'react-redux';
import { nextTask } from '../../study-logic/study-redux-slice';
import { FormControl, FormGroup, FormControlLabel, Checkbox, RadioGroup, Radio, TextField, Button, Typography, MenuItem, Select } from '@mui/material';
import {PageContainer} from "../../survey-tools/ui-components/containers"
import {CustomConfirmationDialog} from '../../survey-tools/custom-dialogue'; // Adjust the import path as needed

function Demographics({ instanceId,nextTask }) {
    const [ethnicity, setEthnicity] = useState({});
    const [gender, setGender] = useState('');
    const [otherGender, setOtherGender] = useState('');
    const [age, setAge] = useState('');
    const [showDialog, setShowDialog] = useState(false);
    const [income, setIncome] = useState('');

    const handleEthnicityChange = (event) => {
        setEthnicity({ ...ethnicity, [event.target.name]: event.target.checked });
    };


    const handleSubmit = () => {
    // Build an array of selected ethnicities
    const selectedEthnicities = Object.entries(ethnicity)
        .filter(([key, value]) => value)
        .map(([key]) => key);

    // Check if at least one ethnicity is selected
    const isEthnicitySelected = selectedEthnicities.length > 0;

    // Check if gender is selected and if 'other' is selected, otherGender should not be empty
    const isGenderSelected = gender && (gender !== 'other' || (gender === 'other' && otherGender));

    // Check if age is selected
    const isAgeSelected = age !== '';

    // Check if income is selected
    const isIncomeSelected = income !== '';

    // Check if all fields are complete
    const isComplete = isEthnicitySelected && isGenderSelected && isAgeSelected && isIncomeSelected;

    if (!isComplete) {
        setShowDialog(true); // Show confirmation dialog if not complete
    } else {
        const demographicsData = { ethnicity: selectedEthnicities, gender: gender === 'other' ? otherGender : gender, age , income};
        nextTask({ data: demographicsData });
        console.log(demographicsData);
    }
};

    const ethnicityOptions = [
        "Black/African American", "Pacific Islander", "Indian Subcontinent", "Middle Eastern",
        "East Asian", "Southeast Asian", "White", "Hispanic American", "Latino/Latina/Latinx",
        "Chicano/Chicana/Chicanx", "Native American", "American Indian"
    ];

    return (
                <PageContainer>

        <div>
                <Typography gutterBottom>Please indicate your ethnicity. Check all that apply.</Typography>
                <FormGroup>
                    {ethnicityOptions.map((option) => (
                        <FormControlLabel
                            key={option}
                            control={<Checkbox checked={ethnicity[option] || false} onChange={handleEthnicityChange} name={option} />}
                            label={option}
                        />
                    ))}
                </FormGroup>

                <div style={{ height: '20px' }}></div> 

            <FormControl component="fieldset" margin="normal">
                <Typography gutterBottom>Check the box that best represents your gender identity.</Typography>
                <RadioGroup
                    value={gender}
                    onChange={(e) => setGender(e.target.value)}
                >
                    <FormControlLabel value="Woman" control={<Radio />} label="Woman" />
                    <FormControlLabel value="Man" control={<Radio />} label="Man" />
                    <FormControlLabel value="Non-binary" control={<Radio />} label="Non-binary" />
                    <FormControlLabel value="other" control={<Radio />} label="Other" />
                    {gender === 'other' && (
                        <TextField
                            label="Please specify"
                            value={otherGender}
                            onChange={(e) => setOtherGender(e.target.value)}
                            variant="outlined"
                            margin="normal"
                            fullWidth
                        />
                    )}
                </RadioGroup>
            </FormControl>
                <div style={{ height: '20px' }}></div> 

            <FormControl fullWidth margin="normal">
            <Typography gutterBottom>How old are you?</Typography>

                <Select
                    value={age}
                    onChange={(e) => setAge(e.target.value)}
                    displayEmpty
                >
                    {Array.from({ length: 82 }, (_, i) => i + 18).map((ageValue) => (
                        <MenuItem key={ageValue} value={ageValue}>
                            {ageValue}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

                            <div style={{ height: '20px' }}></div> 


            <FormControl component="fieldset" margin="normal">
                <Typography gutterBottom>What is your approximate annual household income before taxes? Please select the range that best represents your household's income.</Typography>
                <RadioGroup
                    value={income}
                    onChange={(e) => setIncome(e.target.value)}
                >
                    <FormControlLabel value="Less than $10,000" control={<Radio />} label="Less than $10,000" />
                    <FormControlLabel value="$10,000 - $19,999" control={<Radio />} label="$10,000 - $19,999" />
                    <FormControlLabel value="$20,000 - $29,999" control={<Radio />} label="$20,000 - $29,999" />
                    <FormControlLabel value="$30,000 - $39,999" control={<Radio />} label="$30,000 - $39,999" />
                    <FormControlLabel value="$40,000 - $49,999" control={<Radio />} label="$40,000 - $49,999" />
                    <FormControlLabel value="$50,000 - $59,999" control={<Radio />} label="$50,000 - $59,999" />
                    <FormControlLabel value="$60,000 - $69,999" control={<Radio />} label="$60,000 - $69,999" />
                    <FormControlLabel value="$70,000 - $79,999" control={<Radio />} label="$70,000 - $79,999" />
                    <FormControlLabel value="$80,000 - $89,999" control={<Radio />} label="$80,000 - $89,999" />
                    <FormControlLabel value="$90,000 - $99,999" control={<Radio />} label="$90,000 - $99,999" />
                    <FormControlLabel value="$100,000 - $149,999" control={<Radio />} label="$100,000 - $149,999" />
                    <FormControlLabel value="More than $150,000" control={<Radio />} label="More than $150,000" />
                </RadioGroup>
            </FormControl>



                <div style={{ height: '20px' }}></div> 

            <Button variant="contained" onClick={handleSubmit}>
                Next
            </Button>

            <CustomConfirmationDialog
                open={showDialog}
                onClose={() => setShowDialog(false)}
                onConfirm={() => {
                    setShowDialog(false);
                    const demographicsData = { ethnicity, gender: gender === 'other' ? otherGender : gender, age };
                    nextTask({ data: demographicsData });                }}
            />

        </div>
                </PageContainer>

    );
};

const mapDispatchToProps = { nextTask };
export default connect(null, mapDispatchToProps)(Demographics);
